import { createClient, type SupabaseClient } from "@supabase/supabase-js";

let client: SupabaseClient | null = null;

/**
 * Initialise the Supabase singleton. Idempotent — safe to call multiple
 * times (e.g. in Strict Mode double-mount). Must be called before any
 * other export in this package is used.
 */
export function initSupabase(url: string, anonKey: string): void {
  if (client) return;
  client = createClient(url, anonKey, {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      flowType: "pkce", // callback delivers ?code= query param; prevents hash-fragment loss on SPA redirect
    },
  });
}

export function getClient(): SupabaseClient | null {
  return client;
}

/** True when initSupabase() has been called with non-empty credentials. */
export function isConfigured(): boolean {
  return client !== null;
}
